import React from 'react';
import PermissionService from '../../../services/permission-service';
import Roles from '../../../common/constants/roles';
import PresenterStick from './presenter-stick';
import ParticipantStick from './participant-stick';

const Stick = () => {
  const userRole = PermissionService.getUserRole();
  // todo: detect user role and return specific component

  if (userRole === Roles.ROLE_PRESENTER) {
    return <PresenterStick />;
  } else if (userRole === Roles.ROLE_PARTICIPANT) {
    return <ParticipantStick />;
  }

  return null;
};

export default Stick;
